export { default as FeaturedAndSortedPortals } from './hocs';
